import { initialState, State, Action } from 'store/store';

export const hideHeader = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    hideHeader: data.hide,
  };
};
